import { render, staticRenderFns } from "./car_team_mng_page.vue?vue&type=template&id=5a38b560"
import script from "./car_team_mng_page.vue?vue&type=script&lang=js"
export * from "./car_team_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a38b560')) {
      api.createRecord('5a38b560', component.options)
    } else {
      api.reload('5a38b560', component.options)
    }
    module.hot.accept("./car_team_mng_page.vue?vue&type=template&id=5a38b560", function () {
      api.rerender('5a38b560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/car_team/car_team_mng_page.vue"
export default component.exports